import lottie from 'lottie-web'
import { throttle } from 'underscore'
import MotionTime from './MotionTime'

import animIntroductionDevil from '../../anims/about/devilinside.json'

export default class DevilInsideOfMe {
    constructor() {
        this.introductionPicture = document.querySelector(
            '.introduction__picture'
        )
        this.animIntroductionDevilContainer = this.introductionPicture.querySelector(
            '.introduction__picture-animation'
        )
        this.devilInsideOfMeTimeout = null
        this.motionTime = new MotionTime()
        this.init()
    }

    init() {
        this.initAnimation()
        this.initMouseEvents()
        // this.initTouchEvents();
    }

    initAnimation() {
        this.animIntroductionDevilContainer.innerHTML = ''
        this.animIntroduction = lottie.loadAnimation({
            path: animIntroductionDevil,
            loop: true,
            autoplay: false,
            renderer: 'svg',
            container: this.animIntroductionDevilContainer,
        })
    }

    initMouseEvents() {
        this.mouseMoveEvent = throttle((e) => {
            this.mouseCoords = {
                x: e.clientX,
                y: e.clientY,
            }

            const introduction = document.querySelector(
                '.section__introduction'
            )

            if (introduction) {
                if (
                    introduction.getAttribute('data-scroll-section-inview') !==
                    null
                ) {
                    this.introductionPicture.querySelector(
                        'img'
                    ).style.transform =
                        'perspective(1500px) rotateX(' +
                        (this.mouseCoords.y - window.innerHeight / 2) * 0.04 +
                        'deg) rotateY(' +
                        (this.mouseCoords.x - window.innerWidth / 2) * 0.04 +
                        'deg)'
                    this.animIntroductionDevilContainer.style.transform =
                        'perspective(1500px) rotateX(' +
                        (this.mouseCoords.y - window.innerHeight / 2) * 0.02 +
                        'deg) rotateY(' +
                        (this.mouseCoords.x - window.innerWidth / 2) * 0.02 +
                        'deg)'
                }
            }
        }, 50).bind(this)

        this.introductionPicture.addEventListener(
            'mouseenter',
            this.enteringEvent.bind(this)
        )

        this.introductionPicture.addEventListener(
            'mouseleave',
            this.leavingEvent.bind(this)
        )
    }

    initTouchEvents() {
        this.touchStartEvent = () => {
            this.enteringEvent(true)
        }

        this.introductionPicture.addEventListener(
            'touchstart',
            this.touchStartEvent
        )
        this.introductionPicture.addEventListener(
            'touchend',
            this.leavingEvent.bind(this)
        )
    }

    toggleMoveEvent(disable = false) {
        if (!disable) {
            window.addEventListener('mousemove', this.mouseMoveEvent)
        } else {
            window.removeEventListener('mousemove', this.mouseMoveEvent)
        }
    }

    enteringEvent(event, noMove = false) {
        this.devilInsideOfMeTimeout = setTimeout(() => {
            if (
                !this.animIntroductionDevilContainer.classList.contains(
                    'active'
                )
            ) {
                this.animIntroductionDevilContainer.classList.add('active')

                setTimeout(() => {
                    this.animIntroduction.play()
                    this.motionTime.unlockItem(8)
                }, 200)

                // Triggering the move event
                if (!noMove) {
                    this.toggleMoveEvent()
                }
            }
        }, 2000)
    }

    leavingEvent() {
        clearTimeout(this.devilInsideOfMeTimeout)
        this.devilInsideOfMeTimeout = null
    }

    destroyAll() {
        this.destroyMouseEvents()
        this.destroyTouchEvents()
    }

    destroyMouseEvents() {
        this.toggleMoveEvent(true) // disabling mousemove
        // window.removeEventListener('mousemove', this.mouseMoveEvent)
        this.introductionPicture.removeEventListener(
            'mouseenter',
            this.enteringEvent.bind(this)
        )
        this.introductionPicture.removeEventListener(
            'mouseleave',
            this.leavingEvent.bind(this)
        )
    }

    destroyTouchEvents() {
        this.introductionPicture.removeEventListener(
            'touchstart',
            this.touchStartEvent
        )
        this.introductionPicture.removeEventListener(
            'touchend',
            this.leavingEvent.bind(this)
        )
    }
}
